import React, {useState} from "react";
import {Collapse} from "react-bootstrap";
import Tooltip from "../../../../general/tooltip";
import Alert from "../../../../general/alert";
import Icon from "../../../../general/icon";
import {TIhioDataAndPrescriptionMedicationItemFields} from "../../../../../../types/prescription";
import {general} from "../../../../../../store/action";
import {connect} from "react-redux";

type PrescriptionBulkMedicationPrescriptionRowItemProps = {
    item: TIhioDataAndPrescriptionMedicationItemFields;
    index: number;
    deleteMedicationItemFromList: any;
    isPrescriptionEditable?: boolean;
    visitData?: any
    handleMedicationModalSubmit?: any;
    handleShowModal: any;
}

const PrescriptionBulkMedicationRowItem = ({
    item,
    index,
    deleteMedicationItemFromList,
    isPrescriptionEditable,
    visitData,
    handleMedicationModalSubmit,
    handleShowModal
}: PrescriptionBulkMedicationPrescriptionRowItemProps) => {

    const [showCollapse, setShowCollapse] = useState<boolean>(false)

    return (
        <div className={`card card-custom rounded rounded-4 shadow-none my-3`}>
            <div className="card-header d-flex align-items-center border-bottom-0">
                {isPrescriptionEditable !== false && (
                    <div className='d-flex gap-3'>
                        <Tooltip alt={'ویرایش دارو ترکیبی'}>
                            <span>
                                <button
                                    className={'btn btn-primary rounded rounded-circle py-1 px-2'}
                                    onClick={() => handleShowModal('addPrescriptionBulkItemModal',
                                        {
                                            index: index,
                                            item: item,
                                            visitId: visitData?.id,
                                            handleMedicationModalSubmit: handleMedicationModalSubmit
                                        })}
                                >
                                    <Icon name={'pen-square'}/>
                                </button>
                            </span>
                        </Tooltip>
                        <Tooltip alt={'حذف دارو ترکیبی'}>
                            <span>
                                <button
                                    className={'btn btn-danger rounded rounded-circle py-1 px-2'}
                                    onClick={() => deleteMedicationItemFromList(index)}
                                >
                                    <Icon name={'trash'}/>
                                </button>
                            </span>
                        </Tooltip>
                    </div>
                )}
                <div className='card-title d-flex align-items-center me-auto'>
                    <bdi className='card-label d-flex align-items-center font-16'>
                        <span
                            className={`d-flex align-items-center fw-semibold font-14 cur-pointer me-3 ${showCollapse ? 'text-primary' : 'text-gray'}`}
                            onClick={() => setShowCollapse(!showCollapse)}
                        >
                            مشاهده جزئیات
                        </span>
                        <div
                            className='bg-primary-subtle rounded rounded-4 font-14 mx-2 py-1 px-2'
                            title={`حاوی ${item?.bulkItems?.length} ترکیب`}
                        >
                            حاوی {item?.bulkItems?.length} ترکیب
                        </div>
                        <span className='text-primary'>
                            داروی ترکیبی شماره
                        </span>
                        <span className='text-primary'>
                            &nbsp;{item?.bulkId || 0}
                        </span>
                        <span className='text-dark'>
                            &ensp; .{index + 1}
                        </span>
                    </bdi>
                </div>
            </div>
            <Collapse in={showCollapse}>
                <div>
                    <div className='card-body pt-0'>
                        {item?.bulkItems?.map((bulkItem: any) => {
                            return (
                                <div
                                    className={`card rounded-4 shadow-none border-gray-300 my-3 px-5 py-3`}
                                >
                                    <div className={'d-flex justify-content-between align-items-center'}>
                                        <div className={'d-flex align-items-center gap-3'}>
                                            <span>
                                                {bulkItem?.item?.molecule}
                                            </span>
                                        </div>
                                        <div className={'d-flex align-items-center gap-3'}>
                                            <div
                                                className={'bg-primary text-white rounded rounded-4 py-2 px-3'}
                                            >
                                                مقدار {bulkItem?.itemCount || 0}
                                            </div>
                                            {
                                                bulkItem?.message?.warning?.map((item: string) => {
                                                    return (
                                                        <Tooltip alt={item} className='p-1 '>
                                                            <span className="d-flex align-content-center text-yellow font-20 me-2">
                                                                <Icon name={'info-circle'}/>
                                                            </span>
                                                        </Tooltip>
                                                    );
                                                })
                                            }
                                            {
                                                bulkItem?.message?.info?.map((item: string) => {
                                                    return (
                                                        <Tooltip alt={item} className='p-1 '>
                                                            <span className="d-flex align-content-center text-yellow font-20 me-2">
                                                                <Icon name={'info-circle'}/>
                                                            </span>
                                                        </Tooltip>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className={'text-gray-700'}>
                                        {bulkItem?.drugDescription}
                                    </div>
                                    {
                                        bulkItem?.message?.error?.map((item: string) => {
                                            return (
                                                <div className='mt-3'>
                                                    <Alert
                                                        className={'border-dashed border-danger border-2'}
                                                        type={'danger'}
                                                        text={item}
                                                        icon={'info-circle'}
                                                    />
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Collapse>
        </div>
    )
}


const mapDispatchToProps = (dispatch: any) => ({
    handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PrescriptionBulkMedicationRowItem);